import { createSlice } from '@reduxjs/toolkit';
import waitTimeManager from '../../services/WaitTimeManager';

const initialState = {
  waitTimes: {
    general: "Berechnung...",
    kombi: "Berechnung...",
    minibus: "Berechnung..."
  },
  nextUnavailable: null,
  metadata: null,
  isManagerActive: false,
  lastCalculationTime: null,
  isLoading: false,
  error: null
};

const waitTimeSlice = createSlice({
  name: 'waitTime',
  initialState,
  reducers: {
    setWaitTimes: (state, action) => {
      state.waitTimes = action.payload.waitTimes;
      state.nextUnavailable = action.payload.nextUnavailable;
      state.metadata = action.payload.metadata;
      state.lastCalculationTime = new Date().toISOString();
      state.error = null;
    },
    setManagerStatus: (state, action) => {
      state.isManagerActive = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetWaitTimes: (state) => {
      state.waitTimes = initialState.waitTimes;
      state.nextUnavailable = null;
      state.metadata = null;
      state.lastCalculationTime = null;
      state.error = null;
    }
  }
});

export const {
  setWaitTimes,
  setManagerStatus,
  setLoading,
  setError,
  clearError,
  resetWaitTimes
} = waitTimeSlice.actions;

// Thunk für WaitTimeManager Start
export const startWaitTimeManager = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    dispatch(clearError());
    
    // Aktuelle Daten aus dem Store holen (jetzt von AppDataManager)
    const state = getState();
    const shiftsData = state.appData.shifts;
    const activities = state.appData.activities || [];
    const vehicles = state.appData.vehicles || [];
    
    // Daten an WaitTimeManager übertragen (neue Methode)
    waitTimeManager.updateFromReduxStore(shiftsData, activities, vehicles);
    
    // Update-Callback registrieren
    const unsubscribe = waitTimeManager.registerUpdateCallback((data) => {
      dispatch(setWaitTimes(data));
    });
    
    // Service starten
    await waitTimeManager.start();
    
    dispatch(setManagerStatus(true));
    dispatch(setLoading(false));
    
    console.log('Redux: WaitTimeManager erfolgreich gestartet');
    
    // Cleanup-Funktion für später zurückgeben
    return unsubscribe;
    
  } catch (error) {
    console.error('Redux: Fehler beim Starten des WaitTimeManager:', error);
    dispatch(setError(error.message));
    dispatch(setManagerStatus(false));
  }
};

// Thunk für WaitTimeManager Stop
export const stopWaitTimeManager = () => async (dispatch) => {
  try {
    await waitTimeManager.stop();
    dispatch(setManagerStatus(false));
    dispatch(resetWaitTimes());
    
    console.log('Redux: WaitTimeManager gestoppt');
    
  } catch (error) {
    console.error('Redux: Fehler beim Stoppen des WaitTimeManager:', error);
    dispatch(setError(error.message));
  }
};

// Thunk für Daten-Update
export const updateWaitTimeData = (shiftsData, activities, vehicles, currentDate) => (dispatch, getState) => {
  try {
    // Daten an WaitTimeManager übertragen
    waitTimeManager.updateFromReduxStore(shiftsData, activities, vehicles, currentDate);
    
    // Status-Info für Debugging
    if (process.env.NODE_ENV === 'development') {
      const status = waitTimeManager.getStatus();
      console.log('Redux: WaitTimeManager Daten aktualisiert:', status);
    }
    
  } catch (error) {
    console.error('Redux: Fehler beim Daten-Update:', error);
    dispatch(setError(error.message));
  }
};

// Thunk für manuellen Trigger der Berechnung
export const triggerWaitTimeCalculation = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    
    if (waitTimeManager.getStatus().isActive) {
      await waitTimeManager.performCalculation();
    } else {
      dispatch(setError('WaitTimeManager ist nicht aktiv'));
    }
    
    dispatch(setLoading(false));
    
  } catch (error) {
    console.error('Redux: Fehler bei manueller Berechnung:', error);
    dispatch(setError(error.message));
  }
};

// Selektoren
export const selectWaitTimes = (state) => state.waitTime.waitTimes;
export const selectNextUnavailable = (state) => state.waitTime.nextUnavailable;
export const selectWaitTimeMetadata = (state) => state.waitTime.metadata;
export const selectIsManagerActive = (state) => state.waitTime.isManagerActive;
export const selectWaitTimeLoading = (state) => state.waitTime.isLoading;
export const selectWaitTimeError = (state) => state.waitTime.error;
export const selectLastCalculationTime = (state) => state.waitTime.lastCalculationTime;

export default waitTimeSlice.reducer;